import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { CheckEmail } from '../services/validators/check-email.validator';
import { CheckPassword } from '../services/validators/check-password.validator';
import { UserService } from '../services/user.service';
import { LoginUser } from '../interfaces/login-user.interface';

import { fadeInUp } from '../services/animations/fadeInUp.animation'
import { $ } from 'protractor';

@Component({
    selector: 'app-login',
	templateUrl: './login.component.html',
	animations: [fadeInUp]
})
export class LoginPageComponent implements OnInit {

    loginForm: FormGroup
	errors: Array<any> = []
	messages: Array<any> = []
	verifyStatus: String = ''
	previousUrl: String = ''

    constructor(
        private fbuilder: FormBuilder,
        private userService: UserService,
		private router: Router,
		private route: ActivatedRoute,
    ) {
        this.loginForm = fbuilder.group({
            'email': [null, Validators.compose([Validators.required, CheckEmail])],
            'password': [null, Validators.compose([Validators.required])],
            'keepLoggedIn': [false],
		});
		this.formChanges()
		this.previousUrl = localStorage.getItem('previousUrl')
		const redirectUrl = this.getParameterByName('redirect')
		if (redirectUrl) {
			this.previousUrl = redirectUrl
		}
    }

    ngOnInit() {
		this.errors = [];
		this.messages = [];

		this.verifyStatus = this.route.snapshot.params['id'];
		if (this.verifyStatus) {
			switch (this.verifyStatus) {
				case 'verify-success':
					this.messages.push({ message: 'Account verified successfully' });
					break;
				case 'verify-invalid':
					this.errors.push({ message: 'Invalid or expired account verification link' });
					break;
				case 'reset-success':
					this.messages.push({ message: 'Password reset successful' });
					break;
				case 'reset-invalid':
					this.errors.push({ message: 'Invalid or expired password reset link' });
					break;
				default:
					this.router.navigate(['/login']);
			}
		}
	}

	getParameterByName(name) {
		var regex, results
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
		regex = new RegExp("[\\?&]" + name + "=([^&#]*)")
		results = regex.exec(location.search)
		if (results === null) {
			return ""
		} else {
			return decodeURIComponent(results[1].replace(/\+/g, " "))
		}
	}

	emailInputChange(event) {
		this.loginForm.controls['email'].setValue(event.target.value.trim().toLowerCase())
	}

	formChanges() {
		this.loginForm.valueChanges.subscribe(val => {
			this.errors = [];
			this.messages = [];
		});
	}

    login(isValid: boolean, f: LoginUser) {
		// this.email = f.email;
		this.errors = [];
		this.messages = [];

		if (!isValid) {
			this.errors.push({message: 'Please enter your login details'})
			return;
		}

		this.userService.login(f).subscribe(
			(response: any) => {
				const redirectRoute = this.previousUrl ? this.previousUrl : '/'
				this.router.navigate([redirectRoute])
			},
			(error: any) => {
				var err = error.json();
				this.errors = err;
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts